import { render, staticRenderFns } from "./SubstanceManagementModule.vue?vue&type=template&id=5d5e9d80&scoped=true"
import script from "./SubstanceManagementModule.vue?vue&type=script&lang=js"
export * from "./SubstanceManagementModule.vue?vue&type=script&lang=js"
import style0 from "./SubstanceManagementModule.vue?vue&type=style&index=0&id=5d5e9d80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e9d80",
  null
  
)

export default component.exports